export default __webpack_public_path__ + "static/media/Group 11416.25eef92b.svg";